module.exports = __webpack_public_path__ + "static/assets/ff746430a87f7bc201d151b49ade12e6.png";